import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-form-template',
  template: '<p> app form base </p>'
})
export class FormTemplateComponent {

  @Input()
  form: FormGroup;

  @Input()
  parent: FormGroup;

  @Input()
  name: string;

  @Input()
  noID: boolean = false;

  @Input()
  combine: boolean;

  constructor() { }


  init() {
    if (this.combine) {
      this.form = this.parent;
      if (!this.form.contains('id') && !this.noID) {
        this.form.addControl('id', new FormControl(0));
      }
    } else {
      this.form = new FormGroup({ 'id': new FormControl(0) });
      this.parent.addControl(this.name || 'root', this.form);
    }

    this.template();
  }

  get(name: string): AbstractControl{
    return this.form.get( name );
  }

  template() { }

}



// WEBPACK FOOTER //
// ./src/app/form/core/component/form-template/form-template.component.ts